if (!customElements.get('media-gallery') || !customElements.get('media-gallery-lite')) {
  (function($) {
    var $ = jQuery = $;
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.productGallery = this.querySelector(`.product-single__gallery-${this.dataset.section}`);
        this.thumbnailsWrapper = this.querySelector('.thumbnails-wrapper');
        this.productThumbnails = this.thumbnailsWrapper ? this.thumbnailsWrapper.querySelector('.product-single__thumbnails') : {};
        let selectedMediaId = this.dataset.selectedMediaId;

        this.initBreakpoints();
        this.initGallerySlider();
        this.initThumbnails();
        this.setActiveMedia(selectedMediaId);
      }

      initBreakpoints() {
        enquire.register('screen and (min-width: 1280px)', {
          match: () => {
            this.bpSmall = false;
          },
          unmatch: () => {
            this.bpSmall = true;
          }
        });

        enquire.register("screen and (min-width: 1001px)", {
          match : () => {
            this.blockSlide3DModel = true;
          }
        });
      }

      autoFitIsSupported() {
        const { userAgent } = window.navigator;

        if (userAgent.includes('Firefox/')) {
          // const version = parseInt(userAgent.split('Firefox/')[1]);

          // if (version <= 76) {
          return false;
          // }
        }

        return true;
      }

      initGallerySlider() {
        const self = this;
        const $productGallery = $(this.productGallery);
        const galleryInitialized = $productGallery.hasClass('slick-initialized');
        const optionsGallery = {
          arrows: true
        };
        if(galleryInitialized) return;

        $productGallery.on('init', function(event, slick){
          if (self.blockSlide3DModel === true) {
            const is3DModelActive = $productGallery.find('.slick-current .product-media-modal__model');
            if (is3DModelActive.length) {
              slick.slickSetOption('swipe', false);
            }
          }
        });

        $productGallery.slick(optionsGallery);

        $productGallery.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          self.setActiveThumbnail(null, nextSlide);
        });

        $productGallery.on('afterChange', function(event, slick, currentSlide){
          const activeMedia = $productGallery.find('.slick-current');
          if (activeMedia.length) {
            self.playActiveMedia(activeMedia[0]);
          }

          if (self.blockSlide3DModel === true) {
            const is3DModel = $productGallery.find('.slick-current .product-media-modal__model');

            if (is3DModel.length) {
              slick.slickSetOption('swipe', false);
            } else if (slick.slickGetOption('swipe') ===  false) {
              slick.slickSetOption('swipe', true);
            }
          }
        });

        window.addEventListener('keydown', (event) => {
          if (event.code === 'ArrowLeft') {
            $productGallery.slick('slickPrev');
          } else if (event.code === 'ArrowRight') {
            $productGallery.slick('slickNext');
          }
        });

        // Accessibility concerns not yet fixed in Slick Slider
        $('.product-single__wrapper')
        .find('.slick-list')
        .removeAttr('aria-live');
        $('.product-single__wrapper')
        .find('.slick-disabled')
        .removeAttr('aria-disabled');
      }

      initThumbnails() {
        const thumbImages = this.querySelectorAll(`.product-single__thumbnail--${this.dataset.section}`);
        if (!thumbImages.length) return;

        thumbImages.forEach((thumbImage) => {
          const self = this;

          thumbImage.addEventListener('click', function (e) {
            e.preventDefault();
            const mediaId = this.dataset.thumbnailId;
            self.setActiveThumbnail(mediaId);
          });
        });
      }

      setActiveThumbnail(mediaId = null, nextSlide = null) {
        if (this.filteringMedia || !this.productGallery) return;
        const $gallery = $(this.productGallery);
        const slick = $gallery.slick('getSlick');
        const $thumbImages = $(this).find('.product-single__thumbnail');
        $thumbImages.removeClass('active-thumb').removeAttr('aria-current');
        if (!slick.$slides.length) return;

        const slideIndex = mediaId
          ? slick.$slides.toArray().findIndex((slide) => slide.dataset.mediaId === String(mediaId))
          : (nextSlide ?? slick.currentSlide);
        const slide = slick.$slides[slideIndex];
        if (!slide) return;

        $thumbImages.filter(function () {
          return this.dataset.thumbnailId === slide.dataset.mediaId;
        }).addClass('active-thumb').attr('aria-current', 'true');

        if (mediaId && nextSlide === null) {
          $gallery.slick('slickGoTo', slideIndex, true);
        }
      }

      getGallerySelection(currentVariant) {
        if (currentVariant !== undefined) {
          this.gallerySelection = Array.isArray(currentVariant?.options) ? currentVariant.options : [];
        }
        if (!this.gallerySelection) {
          try {
            const values = JSON.parse(this.dataset.selectedOptions || '[]');
            this.gallerySelection = Array.isArray(values) ? values : [];
          } catch {
            this.gallerySelection = [];
          }
        }
        return this.gallerySelection;
      }

      matchesGallerySelection(alt, values) {
        const normalize = (value) => String(value ?? '').trim().toLowerCase().replace(/\s+/g, ' ');
        const markers = Array.from(String(alt || '').matchAll(/\(([^)]*)\)/g), (match) => normalize(match[1]));
        if (!markers.length) return true;
        if (!values.length || markers.length !== values.length) return false;

        let names;
        try {
          names = JSON.parse(this.dataset.optionNames || '[]');
        } catch {
          names = [];
        }
        if (!Array.isArray(names)) names = [];
        const remaining = values.map((value, index) => ({ name: normalize(names[index]), value: normalize(value) }));
        const orderedMarkers = markers.filter((marker) => marker.includes(':'))
          .concat(markers.filter((marker) => !marker.includes(':')));

        return orderedMarkers.every((marker) => {
          const separator = marker.indexOf(':');
          const name = separator >= 0 ? normalize(marker.slice(0, separator)) : null;
          const value = separator >= 0 ? normalize(marker.slice(separator + 1)) : marker;
          const index = remaining.findIndex((option) => value !== '' && option.value === value && (name === null || option.name === name));
          if (index < 0) return false;
          remaining.splice(index, 1);
          return true;
        });
      }

      setActiveMedia(mediaId, currentVariant) {
        if (!this.productGallery) return;
        const $gallery = $(this.productGallery);
        if (!$gallery.hasClass('slick-initialized')) return;
        const values = this.getGallerySelection(currentVariant);
        const shouldFilter = this.dataset.enableAllImages === 'false';
        const matches = (alt) => !shouldFilter || this.matchesGallerySelection(alt, values);
        const $nav = $(this.productThumbnails);
        const hasNavSlider = $nav.hasClass('slick-initialized');
        const galleryNav = $gallery.slick('slickGetOption', 'asNavFor');
        const navGallery = hasNavSlider ? $nav.slick('slickGetOption', 'asNavFor') : null;

        this.filteringMedia = true;
        try {
          $gallery.slick('slickSetOption', 'asNavFor', null, false);
          if (hasNavSlider) {
            $nav.slick('slickSetOption', 'asNavFor', null, false);
            $nav.slick('slickUnfilter');
          }
          $gallery.slick('slickUnfilter');
          $(this).find('.product-single__thumbnails-item').each((index, element) => {
            const alt = $(element).find('img').attr('data-alt') || '';
            $(element).toggleClass('product-single__thumbnails--hide', !matches(alt));
          });
          if (shouldFilter) {
            $gallery.slick('slickFilter', function () {
              return matches(this.getAttribute('data-alt'));
            });
            if (hasNavSlider) {
              $nav.slick('slickFilter', function () {
                return matches($(this).find('img').attr('data-alt'));
              });
            }
          }
        } finally {
          $gallery.slick('slickSetOption', 'asNavFor', galleryNav, false);
          if (hasNavSlider) $nav.slick('slickSetOption', 'asNavFor', navGallery, false);
          this.filteringMedia = false;
        }

        const slides = $gallery.slick('getSlick').$slides;
        this.productGallery.hidden = slides.length === 0;
        if (this.thumbnailsWrapper) this.thumbnailsWrapper.hidden = slides.length === 0;
        if (!slides.length) {
          this.setActiveThumbnail();
          window.pauseAllMedia(this);
          return;
        }

        const matchedIndex = slides.toArray().findIndex((slide) => slide.dataset.mediaId === String(mediaId));
        const slideIndex = matchedIndex >= 0 ? matchedIndex : 0;
        $gallery.slick('slickGoTo', slideIndex, true);
        $gallery.slick('setPosition');
        if (hasNavSlider) $nav.slick('setPosition');
        this.setActiveThumbnail(null, slideIndex);
        this.playActiveMedia(slides[slideIndex]);
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia(this);
        if (activeItem) {
          const video = activeItem.querySelector('video');

          if (video && video.getAttribute('autoplay')) {
            video.play();
          }

          const deferredMedia = activeItem.querySelector('.deferred-media:not(product-model)');
          if (deferredMedia && deferredMedia.dataset.preventAutoplay) return;
          if (deferredMedia && deferredMedia.loadContent) deferredMedia.loadContent(false);
        }
      }

      get filterOption() {
        return this.dataset.filterOption;
      }

      get productOptions() {
        return this.dataset.productOptions.split(',') || [];
      }

      get productSwatches() {
        return this.dataset.productSwatches.split(',') || [];
      }
    }

    customElements.define('media-gallery', MediaGallery);

    class MediaGalleryLite extends MediaGallery {
      constructor() {
        super();
      }

      initGallerySlider() {
        const self = this;
        const sectionId = this.dataset.section;
        const $productGallery = $(this.productGallery);
        const $galleryNav = $(this.productThumbnails);
        const optionsGallery = {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: $galleryNav
        };
        const optionsNav = {
          slidesToShow: 3,
          slidesToScroll: 1,
          asNavFor: $productGallery,
          centerMode: true,
          centerPadding: '0px',
          focusOnSelect: true,
          vertical: true,
          arrows: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                vertical: false
              }
            }
          ]
        }

        $productGallery.on('init', function(event, slick){
          if (self.blockSlide3DModel === true) {
            const is3DModelActive = $productGallery.find('.slick-current .product-media-modal__model');
            if (is3DModelActive.length) {
              slick.slickSetOption('swipe', false);
            }
          }
        });

        $productGallery.slick(optionsGallery);
        $galleryNav.slick(optionsNav);

        $productGallery.on('beforeChange', function(event, slick, currentSlide, nextSlide){
          self.setActiveThumbnail(null, nextSlide);
        });

        $productGallery.on('afterChange', function(event, slick, currentSlide){
          const activeMedia = $productGallery.find('.slick-current');
          if (activeMedia.length) {
            self.playActiveMedia(activeMedia[0]);
          }

          if (self.blockSlide3DModel === true) {
            const is3DModel = $productGallery.find('.slick-current .product-media-modal__model');

            if (is3DModel.length) {
              slick.slickSetOption('swipe', false);
            } else if (slick.slickGetOption('swipe') ===  false) {
              slick.slickSetOption('swipe', true);
            }
          }
        });

        window.addEventListener('keydown', (event) => {
          if (event.code === 'ArrowLeft') {
            $productGallery.slick('slickPrev');
          } else if (event.code === 'ArrowRight') {
            $productGallery.slick('slickNext');
          }
        });

        // Accessibility concerns not yet fixed in Slick Slider
        $('.product-single__wrapper')
        .find('.slick-list')
        .removeAttr('aria-live');
        $('.product-single__wrapper')
        .find('.slick-disabled')
        .removeAttr('aria-disabled');
      }
    }

    customElements.define('media-gallery-lite', MediaGalleryLite);
  })(theme.jQuery);
}
